module.exports = __webpack_public_path__ + "img/logo-pepz.7baa77a5.svg";